import React, { useState } from "react";
import { useTranslation } from 'react-i18next';

import {
    MenuItem,
    TextField, } from '@material-ui/core';


export default function Address(props) {
    const { t } = useTranslation();

    let fieldName = props.isCollection ? "collection" : "return";
    let labelName = props.isCollection ? "Collection" : "Return";

    if (props.overrideNames){
        fieldName = props.fieldName
        labelName = props.labelName
    }

    const [validLine1, setValidLine1] = useState(null);
    const [validCity, setValidCity] = useState(null);
    const [validPostcode, setValidPostcode] = useState(null);

    const onChange = e => {
      const { name, value } = e.target;

      if (name.includes("Line1")) {        
        setValidLine1(value.length < 1)
      }

      if (name.includes("City")) {        
        setValidCity(value.length < 1)
      }

      if (name.includes("Postcode")) {        
        setValidPostcode(value.length < 1)
      }

      props.onChange(e)
    }

    return (
        <>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="line1"
              label={t(`FormLabels.${labelName}Line1`)}
              name={`${fieldName}Line1`}
              value={props.line1}
              onChange={onChange}
              error={validLine1}
          />
          <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              id="Line2"
              label={t(`FormLabels.${labelName}Line2`)}
              name={`${fieldName}Line2`}
              value={props.line2}
              onChange={onChange}
          />
          <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="city"
              label={t(`FormLabels.${labelName}City`)}
              name={`${fieldName}City`}
              value={props.city}
              onChange={onChange}
              error={validCity}
          />
          <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="postcode"
              label={t(`FormLabels.${labelName}Postcode`)}
              name={`${fieldName}Postcode`}
              value={props.postcode}
              onChange={onChange}
              error={validPostcode}
          />
          <TextField
                variant="outlined"
                margin="normal"
                select
                required
                fullWidth
                id="country"
                label={t(`FormLabels.${labelName}Country`)}
                name={`${fieldName}Country`}
                value={props.country}
              onChange={onChange}
            >
              {
                Object.entries(t('ShippingCountries', { returnObjects: true })).map((countryMap) => (<MenuItem key={countryMap[0]} value={countryMap[0]}>{countryMap[1]}</MenuItem>))
              }
            </TextField>
        </>
    );
}